module.exports = __webpack_public_path__ + "static/media/gsb-iconEntertainment.a022ef84.svg";